import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsSettingsStep.SettingsTable', {
    name: 'Name',
    role: 'Role',
    verification: 'Verification',
    walletOwner: 'Wallet Owner',
});
